import httpClient from '../../../utils/httpClient';

const resource = 'user-settings';

const update = async (body) => {
  const response = await httpClient.PUT(`${resource}`, { body });

  try {
    const data = await response.json();

    return response.ok
      ? {
          status: true,
          data,
        }
      : {
          status: false,
          response,
        };
  } catch (error) {
    return {
      status: false,
      response,
      error,
    };
  }
};

export default {
  update,
};
